(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
function xsFooterInit(){
  document.querySelectorAll('.xs-footer').forEach(footer=>{
    if(footer.dataset.ready)return;
    footer.dataset.ready='true';
    const groups=footer.querySelectorAll('.xs-footer__group');
    const desktop=window.matchMedia('(min-width:750px)');
    const update=()=>groups.forEach(group=>{group.open=desktop.matches;group.querySelector('summary').tabIndex=desktop.matches?-1:0});
    groups.forEach(group=>group.querySelector('summary').addEventListener('click',event=>{if(desktop.matches)event.preventDefault()}));
    desktop.addEventListener('change',update);
    update();
  });
}
xsFooterInit();
document.addEventListener('shopify:section:load',xsFooterInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
